/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AbstractSchemaBean
 */
export interface AbstractSchemaBean {
    /**
     * 
     * @type {number}
     * @memberof AbstractSchemaBean
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof AbstractSchemaBean
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AbstractSchemaBean
     */
    notes?: string;
}

/**
 * Check if a given object implements the AbstractSchemaBean interface.
 */
export function instanceOfAbstractSchemaBean(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AbstractSchemaBeanFromJSON(json: any): AbstractSchemaBean {
    return AbstractSchemaBeanFromJSONTyped(json, false);
}

export function AbstractSchemaBeanFromJSONTyped(json: any, ignoreDiscriminator: boolean): AbstractSchemaBean {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
    };
}

export function AbstractSchemaBeanToJSON(value?: AbstractSchemaBean | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'notes': value.notes,
    };
}

